import React from "react";

function AddIcon({ className }: { className: string }) {
  const [isHovered, setIsHovered] = React.useState(false);

  return isHovered ? (
    <svg
      viewBox="0 0 40.001 33"
      className={className}
      onMouseLeave={() => setIsHovered(false)}
    >
      <g transform="translate(-19)">
        <g
          transform="translate(19)"
          fill="none"
          stroke="#ff8e43"
          strokeWidth="1.5"
          strokeDasharray="5"
        >
          <circle cx="16.5" cy="16.5" r="16.5" stroke="none" />
          <circle cx="16.5" cy="16.5" r="15.75" fill="none" />
        </g>
        <path
          d="M7.273,0A7.273,7.273,0,1,1,0,7.273,7.273,7.273,0,0,1,7.273,0Z"
          transform="translate(44.455 10.182)"
          fill="#ff8e43"
        />
        <text
          transform="translate(48 21)"
          fill="#fff"
          fontSize="14"
          fontFamily="Quicksand-Medium, Quicksand"
          fontWeight="500"
          letterSpacing="-0.024em"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
      </g>
      <g transform="translate(8.008 9.84)">
        <path
          d="M16.2,11.25H5.537a2.164,2.164,0,0,0-2.162,2.162v6.055a2.164,2.164,0,0,0,2.162,2.162H16.2a2.164,2.164,0,0,0,2.162-2.162V13.412A2.164,2.164,0,0,0,16.2,11.25Z"
          transform="translate(-3.375 -7.79)"
          fill="#ff8e43"
        />
        <path
          d="M14.551,4.536,6.086,6.19c-.649.144-1.586.8-1.586,1.589a2.271,2.271,0,0,1,1.766-.685H16.609V6.356A2.069,2.069,0,0,0,16.108,5h0A1.7,1.7,0,0,0,14.551,4.536Z"
          transform="translate(-3.923 -4.499)"
          fill="#ff8e43"
        />
      </g>
    </svg>
  ) : (
    <svg
      viewBox="0 0 40.001 33"
      className={className}
      onMouseEnter={() => setIsHovered(true)}
    >
      <g transform="translate(-19)">
        <g
          transform="translate(19)"
          fill="none"
          stroke="#b9b9b9"
          strokeWidth="1.5"
          strokeDasharray="5"
        >
          <circle cx="16.5" cy="16.5" r="16.5" stroke="none" />
          <circle cx="16.5" cy="16.5" r="15.75" fill="none" />
        </g>
        <path
          d="M7.273,0A7.273,7.273,0,1,1,0,7.273,7.273,7.273,0,0,1,7.273,0Z"
          transform="translate(44.455 10.182)"
          fill="#b9b9b9"
        />
        <text
          transform="translate(48 21)"
          fill="#fff"
          fontSize="14"
          fontFamily="Quicksand-Medium, Quicksand"
          fontWeight="500"
          letterSpacing="-0.024em"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
      </g>
      <g transform="translate(8.008 9.84)">
        <path
          d="M16.2,11.25H5.537a2.164,2.164,0,0,0-2.162,2.162v6.055a2.164,2.164,0,0,0,2.162,2.162H16.2a2.164,2.164,0,0,0,2.162-2.162V13.412A2.164,2.164,0,0,0,16.2,11.25Z"
          transform="translate(-3.375 -7.79)"
          fill="#b9b9b9"
        />
        <path
          d="M14.551,4.536,6.086,6.19c-.649.144-1.586.8-1.586,1.589a2.271,2.271,0,0,1,1.766-.685H16.609V6.356A2.069,2.069,0,0,0,16.108,5h0A1.7,1.7,0,0,0,14.551,4.536Z"
          transform="translate(-3.923 -4.499)"
          fill="#b9b9b9"
        />
      </g>
    </svg>
  );
}

export { AddIcon };
